import RichText from '@/components/elements/RichText';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { IComponentBlocksRichTextColumns } from '@/graphql/__generated__/global/types';
import classNames from '@/lib/classNames';

interface BlockRichTextColumnsProps extends IComponentBlocksRichTextColumns {
    addPaddingX?: boolean;
}

const BlockRichTextColumns = ({ titleDescription, richTextColumns, addBackgroundColour, addPaddingX }: BlockRichTextColumnsProps) => {
    return (
        <Container paddingX={addPaddingX} bg={addBackgroundColour ? 'shell' : null} rounded={addBackgroundColour} wrapperClassName={addBackgroundColour ? 'py-6' : ''}>
            {titleDescription && <TitleAndDescription className="pb-12" {...titleDescription} />}
            <div className="flex flex-col md:flex-row gap-5 sm:gap-8">
                {richTextColumns?.map((richTextColumn, index) => (
                    <RichText
                        key={index}
                        content={richTextColumn.richText}
                        className={classNames(
                            'w-full',
                            richTextColumns?.length === 1 && 'max-w-none',
                            richTextColumns?.length === 2 && 'md:w-1/2',
                            richTextColumns?.length === 3 && 'md:w-1/3'
                        )}
                    />
                ))}
            </div>
        </Container>
    );
};

export default BlockRichTextColumns;
